/**
 *  @class
 *  @function RecentlyViewedProducts
 */
window.recentlyViewedIds = [];
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.product-list-desktop');
      this.containerMobile = this.querySelector('.product-list-mobile');
      
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);
      
      setTimeout(()=>{
        this.fetchProducts();
      }, 1000)
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-list');
          console.log(recommendations);
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.containerMobile.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
          
          // theme.initAnimateOnScroll();

          setTimeout(()=>{
            theme.ProductBlockManager.loadImages(this.container);
            theme.ProductBlockManager.loadImages(this.containerMobile);
            $('.product-form', this.container).trigger('load-product-form');
            setTimeout(()=>{
              theme.loadCarousels(document.querySelector(".recently-viewed-products"));
            },500)

          },500)

          
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}